export const MIN_CHAR_COUNT = 2;
